import React, { Component } from 'react';
import { connect } from "react-redux";
import { withTranslation } from 'react-i18next';
import AgentTabDesc from "./AgentTabDesc";
import AgentDatatable  from "./AgentDatatable";
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import {changeUserState} from "../../actions/actions";
import {seo} from "../../lib/helper";
@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})
class Agents extends Component {

    constructor(props) {
        super(props);



        this.state = {
            data: props.chatprop.allAgents
        };

        this.changeUserState = this.changeUserState.bind(this);


    }

    componentWillUnmount() {
        this.props.dispatch({
            type: 'SET_DOCUMENT_TITLE',
            data: this.props.chatprop.document_default_title
        });
    }

    componentDidMount() {
        this.props.dispatch({
            type: 'SET_DOCUMENT_TITLE',
            data: "HelperVia | Agents"
        });
    }

    changeUserState(e,id) {
       this.props.dispatch(changeUserState(id,e.target.checked));
    }
    deleteRow = (id) => {
        const filteredData = this.state.data.filter((i) =>  i.id !== id);
        this.setState({data: filteredData});
    };
    render() {
        const { t } = this.props;
        return (
            <div className="agent-list-datatable" style={{"marginTop":"5px","padding":"10px"}}>
            <AgentTabDesc modalpage="addAgent" size="lg" title="Agents" description="You can view, edit agents." button_title="Add Agent" />

             <nav>
                    <Tabs defaultActiveKey="allagents" className="filter-tab">
                        <Tab eventKey="allagents" title={"All Agents ("+Object.keys(this.props.chatprop.allAgents).length+")"}>
                            <div>
                                <AgentDatatable type="all"  id="all" editAgent={this.props.editAgent} removeAgent={this.props.removeAgent} openAgentDetail={this.props.openAgentDetail} changeUserState={this.changeUserState}  />

                             </div>
                        </Tab>
                        <Tab eventKey="suspended" title={"Suspended ("+Object.keys(this.props.chatprop.allAgents.filter(agent => agent.state == 2)).length+")"}>
                            <div>
                                <AgentDatatable id="suspended" editAgent={this.props.editAgent} type={(agent=>agent.state===2)}  removeAgent={this.props.removeAgent} openAgentDetail={this.props.openAgentDetail} changeUserState={this.changeUserState}  />

                            </div>
                        </Tab>

                        <Tab eventKey="deleted" title={"Deleted ("+Object.keys(this.props.chatprop.allAgents.filter(agent => agent.state == 3)).length+")"}>
                            <div>
                                <AgentDatatable id="deleted" editAgent={this.props.editAgent} type={(agent=>agent.state===3)}  removeAgent={this.props.removeAgent} openAgentDetail={this.props.openAgentDetail} changeUserState={this.changeUserState}  />

                            </div>
                        </Tab>
                        <Tab eventKey="online" title={"Online ("+Object.keys(this.props.chatprop.allAgents.filter(agent => agent.status == 1)).length+")"}>
                            <div>
                                <AgentDatatable id="online" editAgent={this.props.editAgent} type={(agent=>agent.status===1)}  removeAgent={this.props.removeAgent} openAgentDetail={this.props.openAgentDetail} changeUserState={this.changeUserState}  />

                            </div>
                        </Tab>
                        <Tab eventKey="offline" title={"Offline ("+Object.keys(this.props.chatprop.allAgents.filter(agent => agent.status == 0)).length+")"}>
                            <div>
                                <AgentDatatable id="offline" editAgent={this.props.editAgent} type={(agent=>agent.status===0)}  removeAgent={this.props.removeAgent} openAgentDetail={this.props.openAgentDetail} changeUserState={this.changeUserState}  />

                            </div>
                        </Tab>
                    </Tabs>
                </nav>

            </div>
        );
    }
}

export default withTranslation()(Agents);
